import { Component, Input, ViewEncapsulation } from '@angular/core';
import { News } from '../../shared/interfacce.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notizia',
  templateUrl: './notizia.component.html',
  styleUrls: ['./notizia.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NotiziaComponent {

  constructor(private router: Router) { }

  @Input() notizie: News[] = []
  @Input() notizia!: News
  @Input() index!: number;

  onNotizia(id: number) {
    this.router.navigate(['/news/' + btoa("id_news=" + id)]);
  }
}